import Component from "./Component.js"

export default class Title extends Component {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-title", true)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onmediachange(event) {
    this.setState({textContent: this.player.media.title})
  }
}
